import React from 'react';
import { motion } from 'framer-motion';
import { SlideLayout } from '../SlideLayout';
export function ComparisonSlide() {
  const rows = [{
    label: 'Flexibility',
    gpu: 5,
    tpu: 2,
    asic: 1,
    fpga: 5
  }, {
    label: 'Power Efficiency',
    gpu: 2,
    tpu: 4,
    asic: 5,
    fpga: 4
  }, {
    label: 'Latency',
    gpu: 3,
    tpu: 3,
    asic: 5,
    fpga: 5
  }, {
    label: 'Time-to-Market',
    gpu: 5,
    tpu: 3,
    asic: 1,
    fpga: 5
  }, {
    label: 'NRE Cost',
    gpu: 5,
    tpu: 2,
    asic: 1,
    fpga: 5
  }, {
    label: 'Scalability',
    gpu: 4,
    tpu: 5,
    asic: 5,
    fpga: 4
  }, {
    label: 'Ecosystem',
    gpu: 5,
    tpu: 4,
    asic: 2,
    fpga: 3
  }];
  const renderDots = (count: number, color: string) => <div className="flex gap-2 justify-center" data-id="element-45">
      {[...Array(5)].map((_, i) => <div key={i} className={`w-4 h-4 rounded-full ${i < count ? color : 'bg-brand-border'}`} data-id="element-46" />)}
    </div>;
  return <SlideLayout slideNumber={16} totalSlides={20} title="Head-to-Head" data-id="element-47">
      <div className="w-full h-full flex flex-col" data-id="element-48">
        <motion.h2 initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-4xl md:text-5xl font-bold text-center mb-5" data-id="element-49">
          Architecture Comparison
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.2
      }} className="bg-brand-surface border border-brand-border rounded-2xl overflow-hidden flex-1" data-id="element-50">
          <table className="w-full h-full" data-id="element-51">
            <thead data-id="element-52">
              <tr className="bg-brand-dark border-b border-brand-border" data-id="element-53">
                <th className="p-5 text-left text-brand-muted font-medium text-xl" data-id="element-54">
                  Dimension
                </th>
                <th className="p-5 text-center text-chip-gpu font-bold text-xl" data-id="element-55">
                  GPU
                </th>
                <th className="p-5 text-center text-chip-tpu font-bold text-xl" data-id="element-56">
                  TPU
                </th>
                <th className="p-5 text-center text-chip-asic font-bold text-xl" data-id="element-57">
                  ASIC
                </th>
                <th className="p-5 text-center text-brand-primary font-bold text-xl bg-brand-primary/5" data-id="element-58">
                  FPGA
                </th>
              </tr>
            </thead>
            <tbody data-id="element-59">
              {rows.map(row => <tr key={row.label} className="border-b border-brand-border last:border-0" data-id="element-60">
                  <td className="p-4 px-5 font-medium text-white text-xl" data-id="element-61">
                    {row.label}
                  </td>
                  <td className="p-4 text-center" data-id="element-62">
                    {renderDots(row.gpu, 'bg-chip-gpu')}
                  </td>
                  <td className="p-4 text-center" data-id="element-63">
                    {renderDots(row.tpu, 'bg-chip-tpu')}
                  </td>
                  <td className="p-4 text-center" data-id="element-64">
                    {renderDots(row.asic, 'bg-chip-asic')}
                  </td>
                  <td className="p-4 text-center bg-brand-primary/5 border-l border-r border-brand-primary/10" data-id="element-65">
                    {renderDots(row.fpga, 'bg-brand-primary')}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </motion.div>

        <div className="mt-4 flex justify-center gap-8 text-lg text-brand-muted" data-id="element-66">
          <div className="flex items-center gap-2" data-id="element-67">
            <div className="w-4 h-4 rounded-full bg-brand-border" data-id="element-68" />
            <span data-id="element-69">Poor</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-70">
            <div className="w-4 h-4 rounded-full bg-brand-primary" data-id="element-71" />
            <span data-id="element-72">Excellent</span>
          </div>
        </div>
      </div>
    </SlideLayout>;
}